import { store } from "react-notifications-component";

const notification = (message, type, duration) => {
  return store.addNotification({
    message: message,
    type: type,
    insert: "top",
    container: "top-center",
    animationIn: ["animate__animated", "animate__fadeIn"],
    animationOut: ["animate__animated", "animate__fadeOut"],
    dismiss: {
      duration: duration,
    },
  });
};

export default notification;
